import { ref } from "@vue/composition-api";

const contactExportGenerating = ref(false);
const contactFileContent = ref();

export default function useContactExports() {
    return {
        contactExportGenerating,
        contactFileContent,
    };
}
